import { action } from 'utils/actions'

export const PERFORMANCE_LOAD_PAGE = 'PERFORMANCE_LOAD_PAGE'
export const PERFORMANCE_SET_CALLOVER_LIST_VIEW_TYPE = 'PERFORMANCE_SET_CALLOVER_LIST_VIEW_TYPE'
export const PERFORMANCE_SET_CHANGE_TICKETS_MODAL_EVENT_ID = 'PERFORMANCE_SET_CHANGE_TICKETS_MODAL_EVENT_ID'
export const PERFORMANCE_CHANGE_EVENT_TICKETS = 'PERFORMANCE_CHANGE_EVENT_TICKETS'
export const PERFORMANCE_ACKNOWLEDGE = 'PERFORMANCE_ACKNOWLEDGE'

export const loadPerformancePage = performanceId =>
    action(PERFORMANCE_LOAD_PAGE, { performanceId })
export const setCalloverListViewType = viewType =>
    action(PERFORMANCE_SET_CALLOVER_LIST_VIEW_TYPE, { viewType })
export const changeEventTickets = (eventId, numberOfTickets) =>
    action(PERFORMANCE_CHANGE_EVENT_TICKETS, { eventId, numberOfTickets })
export const acknowledgePerformance = (performanceId, print = false) =>
    action(PERFORMANCE_ACKNOWLEDGE, { performanceId, print })



/** WEBPACK FOOTER **
 ** ./src/actions/performance/performance-actions.js
 **/